
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/summit/error",
      function () {
        return require("private-next-pages/summit/error.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/summit/error"])
      });
    }
  